import React from 'react';
import { CheckIcon } from 'lucide-react';
import { modules } from '../data/content';
export function Modules() {
  return <section aria-label="Included modules" className="bg-mist px-3 py-4 sm:px-6" data-id="element-114" data-mp="1r51250zgqi6v">
      <div className="mx-auto max-w-2xl space-y-2" data-id="element-115" data-mp="1vwsjckwqbbkc">
        {modules.map(mod => <article key={mod.number} className="overflow-hidden rounded-md border border-electric/30 bg-white shadow-sm" data-id="element-116" data-mp="20wolsfps2uxs">
            <div className="flex items-center gap-1.5 bg-electric px-2.5 py-1.5" data-id="element-117" data-mp="146xqwfdkr5rg">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-sun" strokeWidth={3} aria-hidden="true" data-id="element-118" data-mp="186puedo42lpy" />
              <h3 className="font-display text-[0.68rem] font-extrabold uppercase leading-tight text-white sm:text-[0.86rem]" data-id="element-119" data-mp="1d6b2pep686fc">
                MODULE {mod.number} — {mod.title}
              </h3>
            </div>
            <p className="px-2.5 py-2 text-[0.78rem] leading-[1.35] text-navy/80 sm:text-[0.92rem]" data-id="element-120" data-mp="2oky437ns90k6">{mod.body}</p>
          </article>)}
      </div>
    </section>;
}